import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { MatriculaSecretaria } from '../../core/matricula-secretaria';
import { MatriculaSecretariaService } from '../../services/matricula-secretaria/matricula-secretaria.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-matricula-secretaria',
  templateUrl: './matricula-secretaria.component.html',
  styleUrls: ['./matricula-secretaria.component.css']
})
export class MatriculaSecretariaComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  matriculasSecretarias: MatriculaSecretaria[];
  matriculaSecretaria: MatriculaSecretaria = new MatriculaSecretaria();

  mostrarTabela = false;
  msg: string;

  displayedColumns: string[] = ['descricao', 'turno',  'acoes'];

  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  dataSource: MatTableDataSource<MatriculaSecretaria> = new MatTableDataSource();

  constructor(
    private matriculaSecretariaService: MatriculaSecretariaService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.getAll();
  }


  limpar() {
    this.mostrarTabela = false;
    this.matriculaSecretaria = new MatriculaSecretaria();
    this.dataSource.data = [];
  }

  consultar() {
    if (this.matriculaSecretaria.id) {
      this.matriculaSecretariaService.getById(this.matriculaSecretaria.id).subscribe((matriculaSecretaria: MatriculaSecretaria) => {
        if (!matriculaSecretaria) {
          this.mostrarTabela = false;
          this.msg = 'Nenhum registro para a pesquisa selecionada';
        } else {
          this.dataSource.data = [matriculaSecretaria];
          this.mostrarTabela = true;
        }
      })
    } else {
      this.getAll();
    }
  }


  atualizar(matriculaSecretaria: MatriculaSecretaria) {
    this.router.navigate(['/matriculasecretaria/cadastrar'], { queryParams: { id: matriculaSecretaria.id } });
  }

  deletar(matriculaSecretaria: MatriculaSecretaria) {
    this.chamaCaixaDialogo(matriculaSecretaria);
  }

  chamaCaixaDialogo(matriculaSecretaria: MatriculaSecretaria) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a secretaria ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.matriculaSecretariaService.excluir(matriculaSecretaria.id).subscribe(() => {
          this.matriculaSecretaria.id = null;
          this.consultar();
        })
      } else {
        dialogRef.close();
      }
    }
    );
  }

  getAll() {
    this.matriculaSecretariaService.getAll().subscribe((matriculasSecretarias: MatriculaSecretaria[]) => {
      this.matriculasSecretarias = matriculasSecretarias;
      this.dataSource.data = matriculasSecretarias ? matriculasSecretarias : [];
      this.verificaMostrarTabela(matriculasSecretarias);
    })
  }

  verificaMostrarTabela(matriculasSecretarias: MatriculaSecretaria[]) {
    if (!matriculasSecretarias || matriculasSecretarias.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhuma secretaria cadastrada.';
    } else {
      this.mostrarTabela = true;
    }
  }
}
